if (!customElements.get('cc-party-studio-addon')) {
  customElements.define('cc-party-studio-addon', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('change', () => this.sync(), { signal: this.controller.signal });
      this.addEventListener('input', () => this.updateLinks(), { signal: this.controller.signal });
      this.addEventListener('click', event => {
        if (event.target.closest('[data-label-link],[data-coin-link]')) this.updateLinks();
      }, { signal: this.controller.signal });
      queueMicrotask(() => this.sync());
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
    sync() {
      const labels = this.querySelector('[data-request-labels]')?.checked;
      const coins = this.querySelector('[data-request-coins]')?.checked;
      for (const [selector, enabled] of [['[data-label-fields]', labels], ['[data-coin-fields]', coins]]) {
        const fieldset = this.querySelector(selector);
        if (fieldset) {
          fieldset.disabled = !enabled;
          fieldset.hidden = !enabled;
        }
      }
      this.querySelector('[data-studio-notes]').disabled = !labels && !coins;
      this.querySelector('[data-studio-terms]').disabled = !labels && !coins;
      this.updateLinks();
    }
    updateLinks() {
      for (const kind of ['label', 'coin']) {
        const url = new URL('/pages/contact', location.origin);
        url.searchParams.set('view', kind === 'label' ? 'mini-label-quote' : 'coin-quote');
        url.searchParams.set('package', this.dataset.package);
        const enabled = this.querySelector(kind === 'label' ? '[data-request-labels]' : '[data-request-coins]')?.checked;
        const choice = this.querySelector(kind === 'label' ? '[data-label-type]' : '[data-coin-method]');
        const option = choice?.selectedOptions[0];
        const key = kind === 'label' ? option?.dataset.labelType : option?.dataset.method;
        if (enabled && key) url.searchParams.set(kind === 'label' ? 'label_type' : 'method', key);
        if (kind === 'coin') {
          url.searchParams.set('purpose', 'commemorative');
          const material = this.querySelector('[data-coin-material]')?.selectedOptions[0]?.dataset.material;
          if (enabled && material) url.searchParams.set('material', material);
        }
        const quantity = this.querySelector(`[data-${kind}-quantity]`);
        if (enabled && quantity?.value && quantity.checkValidity()) url.searchParams.set('quantity', quantity.value);
        const link = this.querySelector(`[data-${kind}-link]`);
        if (link) link.href = url.pathname + url.search;
      }
    }
  });
}
